const generateStagingConfig = () => ({
    dataMasterPageSizeOptions: [10, 20, 30, 50, 75, 100],
    stripe: {
        publicApiKey:
            "pk_test_51NL989FyGGaWd34WN3SmrlDNH7y2VQdlj0O9H0211N80mJUOpfIZdOuvrElq9bIRB0pjukoad32bnLffyOJRqF3a005taYfmGz",
    },
});

export { generateStagingConfig };
